import * as actionTypes from "../actionTypes";

const initialState = {
  municipalities: [],
  inactiveMunicipalities: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_MUNICIPALITIES:
      return {
        ...state,
        municipalities: action.payload,
      };
    case actionTypes.SET_INACTIVE_MUNICIPALITIES:
      return {
        ...state,
        inactiveMunicipalities: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
